module.exports = __webpack_public_path__ + "img/icon_investmezzanine_process_04.6f03359a.svg";